/**
 * Configuration utility to handle both WordPress and standalone React app contexts
 */

// Get WordPress configuration if available
const wpConfig = window.jaProgramSite || {};

// Check if we're in WordPress context
const isWordPress = document.getElementById('ja-react-root') !== null;

export const config = {
  // API endpoint - use WordPress config if available, otherwise use env variable
  apiEndpoint: isWordPress && wpConfig.api_endpoint
    ? wpConfig.api_endpoint
    : process.env.REACT_APP_API_ENDPOINT || 'https://theschoolschallengehk-backend.jahk.org/2026',

  // Current language
  currentLanguage: isWordPress && wpConfig.current_language
    ? wpConfig.current_language
    : 'zh-hant',

  // Field postfix (EN or TC)
  fieldPostfix: isWordPress && wpConfig.field_postfix
    ? wpConfig.field_postfix
    : 'TC',

  // Active voting sessions
  activeVotingSessions: isWordPress && wpConfig.active_voting_sessions
    ? wpConfig.active_voting_sessions
    : [''],

  // Field translations
  fieldTranslations: isWordPress && wpConfig.field_translations
    ? wpConfig.field_translations
    : {},

  // REST API URLs
  restUrl: isWordPress && wpConfig.rest_url
    ? wpConfig.rest_url
    : '',

  // Nonce for authentication
  nonce: isWordPress && wpConfig.nonce
    ? wpConfig.nonce
    : '',

  // Voting status message
  votingStatus: isWordPress && wpConfig.voting_status
    ? wpConfig.voting_status
    : '',

  // Home and site URLs
  homeUrl: isWordPress && wpConfig.home_url
    ? wpConfig.home_url
    : '/',

  siteUrl: isWordPress && wpConfig.site_url
    ? wpConfig.site_url
    : '/',

  // Base path for routing
  basePath: isWordPress && wpConfig.base_path
    ? wpConfig.base_path.replace(/\/$/, '')
    : '',

  // Check if in WordPress context
  isWordPress: isWordPress,
};

export default config;
